import React from 'react';
import ReactDOM from 'react-dom/client';
import { FAQIndexPage } from './FAQIndexPage';
import { FAQ } from './IFaq';
import '~/styles/main.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

interface WindowWithData extends Window {
  data: FAQ[];
}

const data = (window as unknown as WindowWithData).data || [];

root.render(
  <React.StrictMode>
    <FAQIndexPage faqs={data} />
  </React.StrictMode>
);
